import en from "./english";
import du from "./dutch";
export const SUCCESS = {
  en,
  du,
};
